import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Skeleton } from "@material-ui/lab";

const ProfileHeader = (props) => {
  const { patientData, userImage, imgErrorHandler } = props;
  const navigate = useNavigate();

  if (patientData === null) return <SkeletonHeader />;

  return (
    <Fragment>
      <div className="profile-ph-cont">
        <button className="profile-ph-backBtn" onClick={() => navigate(-1)}>
          Back{" "}
        </button>
      </div>
      <header className="profile-ph-header">
        <div className="profile-ph-patient1">
          <img
            src={userImage}
            alt="Profile"
            width={90}
            height={90}
            onError={imgErrorHandler}
          />
        </div>
        <div className="profile-ph-patient2">
          <span className="profile-ph-name">
            {patientData.fname} {patientData.lname}
          </span>
          <br />
          <span className="profile-ph-phone">{patientData.phone}</span>
        </div>
        <div className="profile-ph-patient3">
          <span className="profile-ph-age">{patientData.age} Years</span>
          <span className="profile-ph-age">
            {patientData.height},{patientData.weight} LBS
          </span>
          <span className="profile-ph-age">
            Blood Group: {patientData.bloodGroup}
          </span>
        </div>
        <div className="profile-ph-patient4">
          <span className="profile-ph-contactDetails">Contact Details</span>
          <span className="profile-ph-email">{patientData.email}</span>
          <span className="profile-ph-address">{patientData.address}</span>
        </div>
        <div className="profile-ph-patient5">
          <button className="profile-ph-btn">Generate PDF</button>
          <button className="profile-ph-btn" onClick={props.showChatModal}>
            Message Patient
          </button>
        </div>
      </header>
    </Fragment>
  );
};

const SkeletonHeader = () => {
  return (
    <Fragment>
      <div className="profile-ph-cont">
        <button className="profile-ph-backBtn">Back </button>
      </div>
      <header className="profile-ph-header">
        <div className="profile-ph-patient1">
          <Skeleton variant="circle" width={90} height={90} />
        </div>
        <div className="profile-ph-patient2">
          <span className="profile-ph-name">
            <Skeleton variant="text" width={100} />
          </span>
          <br />
          <span className="profile-ph-phone">
            <Skeleton variant="text" width={100} />
          </span>
        </div>
        <div className="profile-ph-patient4">
          <span className="profile-ph-contactDetails">
            <Skeleton variant="text" width={100} />
          </span>
          <span className="profile-ph-email">
            <Skeleton variant="text" width={100} />
          </span>
          <span className="profile-ph-address">
            <Skeleton variant="text" width={100} />
          </span>
        </div>
        <div className="profile-ph-patient3">
          <span className="profile-ph-age">
            <Skeleton variant="text" width={100} />
          </span>
          <span className="profile-ph-age">
            <Skeleton variant="text" width={100} />
          </span>
          <span className="profile-ph-age">
            <Skeleton variant="text" width={100} />
          </span>
        </div>
        <div className="profile-ph-patient5">
          <button className="profile-ph-btn">Generate PDF</button>
          <button className="profile-ph-btn">Message Patient</button>
        </div>
      </header>
    </Fragment>
  );
};

export default ProfileHeader;
